import { Workbook } from "exceljs";
import { RowData, JsonSchema, LandingPageOptions } from "../../../../types";
import {  formatWorksheet } from "./formatAndProtectCOAWorksheet";
import saveAs from "file-saver";
import { flattenCOARowData } from "./flattenCOARowData";

export const exportCOAToExcel = async (
  rowData: RowData[],
  fileName: string,
  schema: JsonSchema,
  selected: LandingPageOptions,
): Promise<void> => {
  const flattenedData = flattenCOARowData(rowData, schema);

  if (!flattenedData.length) {
    return;
  }

  const workbook = new Workbook();
  const worksheet = workbook.addWorksheet(selected.setup.label);

  const headers = Object.keys(flattenedData[0]);
  worksheet.addRow(headers);
  worksheet.addRows(flattenedData.map((row) => Object.values(row)));

   formatWorksheet(worksheet);

  const buffer = await workbook.xlsx.writeBuffer();

  saveAs(
    new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    }),
    `${fileName}.xlsx`,
  );
};
